import { render } from "./DashboardInfo.vue?vue&type=template&id=0d5b8da5"
import script from "./DashboardInfo.vue?vue&type=script&lang=js"
export * from "./DashboardInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__